import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  connectedCallback() {
    super.connectedCallback();
    const form = this.refs.searchPageInput.form ?? this.closest('form');
    form?.addEventListener('submit', this.#handleSubmit);

    // Restore clean display query in the input if display_q param exists
    const params = new URL(window.location.href).searchParams;
    const displayQuery = params.get('display_q');
    if (displayQuery) {
      this.refs.searchPageInput.value = displayQuery;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const form = this.refs.searchPageInput.form ?? this.closest('form');
    form?.removeEventListener('submit', this.#handleSubmit);
  }

  #doSearch(query) {
    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', `${query}* OR ${query}`);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('display_q', query);
    window.location.href = url.toString();
  }

  #handleSubmit = (event) => {
    event.preventDefault();
    const query = this.refs.searchPageInput.value.trim();
    if (!query) return;
    this.#doSearch(query);
  };

  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();
    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
      return;
    }
    if (event.key === 'Enter' && value !== '') {
      event.preventDefault();
      this.#doSearch(value);
    }
  }, 200);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;
    searchInput.focus();
    searchInput.value = '';
    if (this.#isEmptyState()) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', '');
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const displayQuery = url.searchParams.get('display_q') ?? '';
    const queryParam = url.searchParams.get('q') ?? '';
    return displayQuery.trim() === '' && queryParam.trim() === '';
  };
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}